import React, { useEffect, useRef } from 'react';
import { ScrollActivator } from 'acq-components/lib/utils/ScrollActivator/ScrollActivator';
import CardListCarousel from './CardListCarousel';
import PartialShadowBox from './PartialShadowBox';
import { isIOS, getWinWidth } from 'src/universal/utils/clientSideDetection';
import parentStyles from 'page_modules/business-vac/components/PillboxFilter/__styles__/index.scss?modules';
import styles from './__styles__/index.scss?modules';

const CarouselCardList = () => {
  const stickyEleRef = useRef(null);
  const filterBoxRef = useRef(null);
  const carouselRef = useRef(null);
  const isFilterSickyOn = useRef(false);
  const isScrolledToEnd = useRef(false);
  const isMobile = getWinWidth() <= 767;

  useEffect(() => {
    setTimeout(() => {
      stickyEleRef.current = document.querySelector(
        '.filter-card-tile-container > div > div[style*="sticky"]'
      );
      filterBoxRef.current = document.querySelector(`.${parentStyles.carousel}`);
      carouselRef.current = document.querySelector(`.${styles.shadowBoxOuter}`);
    }, isIOS() ? 4000 : 2000);
  }, []);

  const updateStickyIndicator = stickinessOn => {
    const filterBox = filterBoxRef.current;
    if (!filterBox) {
      return;
    }
    if (stickinessOn != isFilterSickyOn.current) {
      const action = stickinessOn ? 'add' : 'remove';
      filterBox.classList[action](parentStyles.stickyOn);
      isFilterSickyOn.current = stickinessOn;
    }
  };

  const updateScrolledToEndIndicator = isAtEnd => {
    // isAtEnd = it has been upward-scrolled to the state of completed behind/under the filter.
    const filterBox = filterBoxRef.current;
    if (!filterBox) {
      return;
    }
    if (isAtEnd != isScrolledToEnd.current) {
      const action = isAtEnd ? 'add' : 'remove';
      filterBox.classList[action](parentStyles.carouselScrolledToEnd);
      isScrolledToEnd.current = isAtEnd;
    }
  };

  const scrollHandler = () => {
    const stickyEle = stickyEleRef.current;
    if (typeof stickyEle?.getBoundingClientRect === 'function') {
      const stickyRect = stickyEle.getBoundingClientRect();
      const threshold = isMobile ? 10 : 60;
      updateStickyIndicator(!!(stickyRect.top <= threshold));
    }

    const currBox = carouselRef.current;

    if (typeof currBox?.getBoundingClientRect === 'function') {
      const currBoxRect = currBox.getBoundingClientRect();
      // these vals need to be updated when the component css for PartialShadowBox gets changed.
      const threshold = isMobile ? -25 : -32;
      updateScrolledToEndIndicator(!!(currBoxRect.top <= threshold));
    }

    return false;
  };

  return (
    <ScrollActivator onScroll={scrollHandler}>
      {shouldHide => {
        return (
          <PartialShadowBox>
            <CardListCarousel shouldHide={shouldHide} />
          </PartialShadowBox>
        );
      }}
    </ScrollActivator>
  );
};

export default React.memo(CarouselCardList);
